module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (223).31ae867e.jpg";